import axios from "axios";
import { GURL } from "./global";

axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem(
  "token"
)}`;

// Service for fetching invitations with OData query parameters
export const GetInvitationsOData = (
  top: number = 10,
  skip: number = 0,
  orderBy: string = "",
  filters: string = ""
) => {
  // Convert filters into OData $filter conditions with 'contains' for each filter
  console.log("filll", filters);

  const url = `${GURL}/Company/odata/InvitationOData?$top=${top}&$skip=${skip}&$count=true&$expand=Company($expand=Positions),InvitationCode,InvitationEvents&${orderBy}&${filters}`;

  return axios.get(url);
};
